var TemplatesService = /** @class */ (function () {
    function TemplatesService(api) {
        this.API = api;
    }
    TemplatesService.prototype.createTemplate = function (template) {
        var url = "/templates";
        return this.API.post(url, template);
    };
    TemplatesService.prototype.getTemplateData = function (templateId) {
        var url = "/templates/".concat(templateId);
        return this.API.get(url);
    };
    TemplatesService.prototype.getTemplateEnvData = function (templateId) {
        var url = "/templates/".concat(templateId, "/environments");
        return this.API.get(url);
    };
    TemplatesService.prototype.updateTemplate = function (template, templateId) {
        var url = "/templates/".concat(templateId);
        return this.API.patch(url, template);
    };
    TemplatesService.prototype.deleteTemplate = function (templateID) {
        var url = "/templates/".concat(templateID);
        return this.API.delete(url);
    };
    TemplatesService.prototype.deleteTemplateEnv = function (templateID, environmentId, section) {
        var url = "/templates/".concat(templateID, "/environments?environment_id=").concat(environmentId, "&section=").concat(section);
        return this.API.delete(url);
    };
    TemplatesService.prototype.getAllTemplates = function () {
        var url = "/templates";
        return this.API.get(url);
    };
    TemplatesService.prototype.getOrganizationTemplates = function (organizationId) {
        var url = "/templates/organization=".concat(organizationId);
        return this.API.get(url);
    };
    TemplatesService.prototype.clearMedia = function (appId) {
        var scope = "app:".concat(appId, ":template");
        var url = "/scheduler/templatemedia?scope=".concat(scope);
        return this.API.delete(url);
    };
    TemplatesService.prototype.getTemplatesWithProps = function (organizationId, page, perPage, categories, name, type) {
        if (organizationId === void 0) { organizationId = ''; }
        if (page === void 0) { page = 1; }
        if (perPage === void 0) { perPage = 16; }
        if (categories === void 0) { categories = ''; }
        if (name === void 0) { name = ''; }
        if (type === void 0) { type = 'solution'; }
        var url = '';
        if (type === 'all') {
            url = "/templates/organization=".concat(organizationId, "?per_page=").concat(perPage, "&page=").concat(page).concat(categories, "&search=").concat(name, "&published=true");
        }
        else if (type === 'legacy') {
            url = "/templates/organization=".concat(organizationId, "?per_page=").concat(perPage, "&page=").concat(page).concat(categories, "&type=").concat(type, "&search=").concat(name, "&published=true");
        }
        else {
            url = "/templates/organization=".concat(organizationId, "?per_page=").concat(perPage, "&page=").concat(page).concat(categories, "&type=").concat(type, "&search=").concat(name, "&published=true");
        }
        return this.API.get(url);
    };
    TemplatesService.prototype.getTemplateEnvironmentData = function (templateId) {
        var url = "/templates/".concat(templateId, "/environments");
        return this.API.get(url);
    };
    TemplatesService.prototype.getInitialTemplates = function (organizationId) {
        var url = "/templates/organization=".concat(organizationId, "?init=true");
        return this.API.get(url);
    };
    return TemplatesService;
}());
export { TemplatesService };
